import type { SeoDeparture, SeoDepartureCity } from '@travelata-libs/travelata-frontend';
import type Backbone from 'backbone';
import { reactive } from 'vue';
import DepartureCitiesRepository from '@/js/common/Domain/Repository/DepartureCities';
import { mountLibSeoTitle } from './mountLibSeoTitle';

const toCity = (model: Backbone.Model): SeoDepartureCity => ({ id: model.get('id'), name: model.get('name') });

// Город — в модели страницы globalDepartureCity: шапка его показывает и меняет, цены грузит страница.
export function mountLibCalendarHeader(departureField: Backbone.Model): void {
    mountLibSeoTitle((seoProps) => {
        const ssrDeparture = seoProps.departure as SeoDeparture | undefined;
        const repository = DepartureCitiesRepository.repository;
        const departure = reactive<SeoDeparture>({
            label: ssrDeparture?.label ?? '',
            placeholder: ssrDeparture?.placeholder ?? '',
            // Пока страница грузит критерии, показываем город региона из серверной разметки.
            city: departureField.get('model') ? toCity(departureField.get('model')) : ssrDeparture?.city ?? null,
            cities: repository.map((model: Backbone.Model) => toCity(model)),
        });

        departureField.on('change:model', (_field: Backbone.Model, model: Backbone.Model | null) => {
            departure.city = model ? toCity(model) : null;
        });
        repository.on('update reset', () => {
            departure.cities = repository.map((model: Backbone.Model) => toCity(model));
        });

        return {
            props: { departure },
            listeners: {
                ['change:departure']: (city: SeoDepartureCity) => {
                    departureField.set('model', repository.get(city.id));
                },
            },
        };
    });
}
